<template>
  <div class="ts-overflow-hidden">
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <div class="ts-justify-start">
            <ts-button color="info" outline @click.prevent="() => (show_form = true)">{{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="ts-flex">
            <!-- <label class="form-col-label control-label ts-mb-2"></label> -->
            <ts-input v-model="search" style="width: 300px;" :placeholder="$t('eventInvitation.search')" />
            <ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" showGroupIcon groupIcon="fa fa-file-pdf"
          :rowGroup="{
            field: 'invitation_title'
          }" @actionGroup="onActionGroup">
          <template v-slot="{ record }">
            <td>
              {{ record.branch_name_en }}
            </td>
            <td class="ts-text-center">
              {{ record.invitation_number }}
            </td>
            <td class="ts-text-center">
              {{ record.card_number }}
            </td>
            <td>
              {{ record.student_name_en }}
            </td>
            <td>
              {{ record.class_name }}
            </td>
            <td>
              {{ record.grade_name_foreign }}
            </td>
            <td class="ts-text-center">
              {{ record.ac_year }}
            </td>
            <td>
              {{ record.term_name }}
            </td>
            <td>
              {{ record.user_created_by }}
            </td>
            <td>
              {{ record.created_date }}
            </td>
            <td class="text-right ts-whitespace-no-wrap ts-px-8">
              <a href="#" class="mr-2 text-info" @click.prevent="previewPdf(record.invitation_id, record.id)"
                v-tooltip="$t('preview')">
                <i class="fas fa-file-pdf"></i>
              </a>
              <!-- <a
                href="#"
                class="text-danger"
                @click.prevent="deleteRecord(record.invitation_id)"
                :disabled="record._deleting"
                v-tooltip="$t('delete')"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a> -->
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <a-modal v-if="show_form" v-model="show_form" :title="$t('eventInvitation.pageTitle')" :zIndex="1020" :footer="null"
      :maskClosable="false" width="60%" @cancel="close">
      <form-component ref="form_component" @close="() => (show_form = false)" @fetchData="fetchData" @cancel="close" />
    </a-modal>
    <a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible"
      @close="() => (visible = false)" :zIndex="1020" width="400px">
      <ts-loading-banner :loading="loadingFilter">
        <div class="ts-space-y-3">
          <div class="row">
            <div class="col-md-12 ts-mb-2">
              <label>{{ $t('eventInvitation.eventDate') }}</label>
              <a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
                @change="dateRangeChange">
                <template slot="renderExtraFooter"></template>
              </a-range-picker>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t('eventInvitation.academicYear') }}</label>
              <div class="form-group ts-w-full">
                <a-select style="width: 100%" v-model="ac_year_id" :options="years" showSearch mode="multiple"
                  :filterOption="(input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                    " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t('eventInvitation.subject') }}</label>
              <a-select v-model="invitation_subject_id" mode="multiple" style="width: 100%" :placeholder="$t('all')"
                :max-tag-count="1" :max-tag-text-length="10" :options="invitationSubjects" :filterOption="(input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                  "></a-select>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </a-drawer>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import FormComponent from './form'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import PreviewPdf from './preview-pdf'

export default {
  name: 'eventInvitation',
  components: {
    FormComponent,
    PreviewPdf
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      show_form: false,
      visible: false,
      loadingFilter: false,
      subject_loading: false,
      model: {},
      rangeDate: [moment().add(-1, 'months'), moment()],
      years: [],
      invitationSubjects: [],
      invitation_id: null
    }
  },
  computed: {
    ...mapState('eventInvitation', ['resources', 'pagination']),
    columns() {
      return [
        {
          name: this.$t('eventInvitation.branchName')
        },
        {
          name: this.$t('eventInvitation.invitationNo'),
          style: 'text-align: center;'
        },
        {
          name: this.$t('eventInvitation.cardNumber'),
          style: 'text-align: center;'
        },
        {
          name: this.$t('eventInvitation.studentName')
        },
        {
          name: this.$t('eventInvitation.className')
        },
        {
          name: this.$t('eventInvitation.gradeName')
        },
        {
          name: this.$t('eventInvitation.academicYear'),
          style: 'text-align: center;'
        },
        {
          name: this.$t('eventInvitation.academicTerm')
        },
        {
          name: this.$t('eventInvitation.createdBy')
        },
        {
          name: this.$t('eventInvitation.createdDate')
        },
        {
          name: this.$t('action'),
          style: 'text-align: right;'
        }
      ]
    },
    search: {
      get() {
        return this.$store.state.eventInvitation.search
      },
      set(val) {
        this.$store.commit('eventInvitation/SET_SEARCH', val)
      }
    },
    ac_year_id: {
      get() {
        return this.$store.state.eventInvitation.ac_year_id
      },
      set(newValue) {
        this.$store.commit('eventInvitation/SET_YEAR_ID', newValue)
      }
    },
    invitation_subject_id: {
      get() {
        return this.$store.state.eventInvitation.invitation_subject_id
      },
      set(newValue) {
        this.$store.commit(
          'eventInvitation/SET_INVITATION_SUBJECT_ID',
          newValue
        )
      }
    }
  },
  created() {
    this.fetchResource()
  },
  methods: {
    async fetchResource() {
      await this.$store
        .dispatch('reportAcademic/getYear')
        .then(response => {
          this.years = response.data.map(el => ({
            value: el.ac_year_id,
            label: el.ac_year
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('eventInvitation/getInvitationSubject')
        .then(response => {
          this.invitationSubjects = response.data.map(el => ({
            value: el.id,
            label: el.subject_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('eventInvitation/fetch', attributes)
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'eventInvitation/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'eventInvitation/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    deleteRecord(invitation_id) {
      this.loading = true
      this.$store
        .dispatch('eventInvitation/destroy', invitation_id)
        .then(response => {
          this.loading = false
          this.fetchData()
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onActionGroup(props) {
      this.previewPdf(props.invitation_id)
    },
    previewPdf(invitation_id, id = null) {
      this.$modal.show(
        PreviewPdf,
        {
          invitation_id: invitation_id,
          id: id
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    close() {
      this.show_form = false
      this.fetchData()
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('eventInvitation/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
    ac_year_id: debounce(function (value) {
      this.fetchData({ ac_year_id: value })
    }, 500),
    invitation_subject_id: debounce(function (value) {
      this.fetchData({ invitation_subject_id: value })
    }, 500)
  }
}
</script>
<style scoped lang="scss"></style>
